/**
 * PPR-3 E / F · 同行订单事件（后台）服务层。
 * 契约：routes/order_partner_events.py（PPR-2：订单上读 / 回复）+ routes/partner_events_admin.py（PPR-3：聚合只读）。
 * 事件只是沟通记录——回复 / 关闭不会自动改订单（改名单 / 改人数 / 改期 / 取消仍在订单详情里手工做）。
 */
import { api } from "./api";

export type EventStatus = "open" | "in_progress" | "closed";

export interface OrderPartnerEvent {
  id: string;
  order_id: string;
  type: string;
  type_label: string;
  urgency: "normal" | "urgent" | string;
  content: string;
  status: EventStatus | string;
  status_label: string;
  created_by: string | null;
  created_at: string;
  reply: string | null;
  replied_by: string | null;
  replied_at: string | null;
}

export interface PartnerEventRow {
  id: string;
  order_id: string;
  order_no: string;
  partner_ref: string | null;
  partner_id: string;
  partner_name: string;
  travel_date: string | null;
  type: string;
  type_label: string;
  urgency: string;
  content: string;
  status: string;
  status_label: string;
  created_at: string;
  replied_at: string | null;
}
export interface PartnerEventList { open_count: number; items: PartnerEventRow[] }

export const PE_QK = {
  order: (id: string) => ["partner-events", "order", id] as const,
  partner: (id: string) => ["partner-events", "partner", id] as const,
  queue: ["partner-events", "queue"] as const,
  counts: (ids: string) => ["partner-events", "counts", ids] as const,
};

export const getOrderPartnerEvents = (orderId: string): Promise<OrderPartnerEvent[]> => api(`/api/v1/orders/${orderId}/partner-events`);
export const replyOrderPartnerEvent = (orderId: string, eventId: string, body: { reply?: string; status?: EventStatus }): Promise<OrderPartnerEvent> =>
  api(`/api/v1/orders/${orderId}/partner-events/${eventId}`, { method: "PATCH", body: JSON.stringify(body) });
export const getPartnerEvents = (partnerId: string, status: "open" | "all" = "open"): Promise<PartnerEventList> =>
  api(`/api/v1/channel-partners/${partnerId}/partner-events?status=${status}`);
export const getPartnerEventQueue = (status: "open" | "all" = "open"): Promise<PartnerEventList> => api(`/api/v1/partner-events?status=${status}`);
export const getPartnerEventOpenCounts = (orderIds: string[]): Promise<Record<string, number>> =>
  api(`/api/v1/partner-events/open-counts?order_ids=${orderIds.join(",")}`);

export const EVENT_STATUS_TONE: Record<string, string> = {
  open: "bg-amber-50 text-amber-700", in_progress: "bg-blue-50 text-blue-700", closed: "bg-slate-100 text-slate-500",
};
